import type { CharitySuggestElements } from '../../types/pifster-contracts';

function requireElement<T extends Element>(
  container: HTMLElement,
  selector: string,
  label: string,
): T {
  const el = container.querySelector<T>(selector);
  if (!el) {
    throw new Error(`[charity-suggest] Required element missing: ${label} (${selector})`);
  }
  return el;
}

/**
 * Cache all DOM references for the charity suggest form.
 *
 * @throws {Error} If any required element is missing (fail-fast).
 */
export function cacheSuggestElements(container: HTMLElement): CharitySuggestElements {
  const form = requireElement<HTMLFormElement>(container, '#pifster-charity-suggest-form', 'form');
  const nameInput = requireElement<HTMLInputElement>(container, '#pifster-charity-name', 'nameInput');
  const resultsEl = requireElement<HTMLElement>(container, '#pifster-charity-suggest-results', 'resultsEl');
  const submitBtn = requireElement<HTMLButtonElement>(container, '#pifster-charity-suggest-submit', 'submitBtn');
  const statusEl = requireElement<HTMLElement>(container, '#pifster-charity-suggest-status', 'statusEl');
  const turnstileEl = requireElement<HTMLElement>(container, '#pifster-turnstile', 'turnstileEl');

  return {
    form,
    nameInput,
    urlInput: container.querySelector<HTMLInputElement>('#pifster-charity-url'),
    reasonInput: container.querySelector<HTMLInputElement | HTMLTextAreaElement>('#pifster-user-reason'),
    suggesterNameInput: container.querySelector<HTMLInputElement>('#pifster-suggester-name'),
    suggesterEmailInput: container.querySelector<HTMLInputElement>('#pifster-suggester-email'),
    websiteInput: container.querySelector<HTMLInputElement>('#pifster-website'),
    resultsEl,
    hintEl: container.querySelector<HTMLElement>('#pifster-charity-suggest-hint'),
    submitBtn,
    statusEl,
    turnstileEl,
    autocompleteWrap: nameInput.closest<HTMLElement>('.pifster-charity-suggest__autocomplete'),
    clearBtn: container.querySelector<HTMLElement>('.pifster-charity-suggest__clear'),
  };
}
